import { ColorMatrix } from "./types";

export const COLOR_MATRIX: ColorMatrix = {
  LIGHT: {
    colors: {
      value_01: "#ffffff",
      value_02: "#000000",
      value_03: "#1976d2",
      value_04: "#3f51b5",
      value_05: "#79D3CD",
      value_06: "#4ec7bd",
      value_07: "#727272",
      value_08: "#EFEFEF",
      value_09: "#FCAE9D",
      value_10: "#767676",
      value_11: "#A7A4A4",
      value_12: "#B2B2B2",
      value_13: "#FF0000",
      value_14: "#F0FEFF",
      value_15: "#565656",
      value_16: "#ACACAC",
      value_17: "#01133d",
      value_18: "#283960",
      value_19: "#E5E5E5",
      value_20: "#34BAE4",
      value_21: "#F9F9F9",
      value_22: "#4FC8EE",
      value_23: "#606B84",
      value_24: "#F9F9FB",
      value_25: "#d3d3d3",
      value_26: "#B6BAC2",
      value_27: "#4E5C7C",
      value_29: "#6A7BA0",
      value_30: "#352479",
      value_31: "#ACB6CB",
      value_32: "#CDD4E2",
      value_33: "#ECECF1",
      value_34: "#5CBA7C",
      value_35: "#EF5DA8",
      value_36: "#DBCA30",
      value_37: "#CCD2E3",
      value_38: "#289d60",
      value_39: "#E43434",
      value_40: "#E45E34",
      value_41: "#B6E434",
      value_42: "#3446E4",
      value_43: "#34E446",
      value_44: "#EFA35D",
      value_45: "#f9f9fd",
      value_46: "#F0C350",
      value_47: "#314267",
      value_48: "#F4F5F8",
      value_51: "#4F4F4F",
      value_52: "#9DD1FF",
      value_53: "#BAD2FC",
      value_54: "#3347F2",
      value_55: "#3B2716",
      value_56: "#A9E44D",
      value_58: "#04091E",
      value_59: "#F0C350",
      value_60: "#FF8B92",
      value_61: "#FAEE86",
      value_62: "#A1EDA9",
      value_63: "#A0C0FF",
      value_64: "#4B5D7D",
      value_65: "#4e5c7c",
      value_66: "#4e5c7c",
      value_67: "#f4f5f8",
      value_68: "#ffffff",
    },
    rgb: {
      value_01: "#ffffff",
      value_02: "rgba(78, 92, 124, 0.25)",
      value_03: "rgba(40, 57, 96, 0.15)",
      value_04: "rgba(252, 210, 129, 0.45)",
      value_05: "rgba(255, 255, 255, 0.45)",
      value_06: "rgba(52, 186, 228, 0.1)",
      value_07: "rgba(255, 255, 255, 0.5)",
      value_08: "rgba(inherit, inherit, inherit, 0)",
      value_09: "rgba(40, 57, 96, 0.8)",
      value_10: "#CDD4E2",
      value_11: "#283960",
      value_12: "rgba(inherit, inherit, inherit, 0)",
      value_13: "rgba(106,123,160,0.8)",
      value_14: "rgba(52, 186, 228, 0.2)",
      value_15: "rgba(40, 57, 96, 0.25)",
      value_16: "rgba(1, 19, 61, 0.1)",
      value_17: "rgba(239, 93, 168, 0.1)",
      value_18: "#ACB6CB",
      value_19: "rgba(52, 186, 228, 0.1)",
      value_20: "rgba(219,202,48,0.1)",
      value_21: "rgba(255,255,255,0.9)",
      value_22: "rgba(239, 93, 168, 0.15)",
      value_23: "rgba(92,186,124, 0.5)",
      value_24: "rgba(92,186,124, 0.15)",
      value_25: "rgba(239,93,168,0.15)",
      value_26: "rgba(52,186,228,0.1)",
      value_27: "rgba(239,93,168,0.1)",
      value_28: "rgba(92, 186, 124, 0.2)",
      value_29: "rgba(1, 19, 61, 0.12)",
      value_30: "rgba(92, 186, 124, 0.1)",
      value_31: "#314267",
      value_32: "#01133D",
      value_33: "rgba(236, 236, 241, 0.5)",
      value_34: "rgba(219, 202, 48, 0.1)",
      value_35: "rgba(229, 229, 229, 0.5)",
      value_36: "rgba(205, 212, 226, 0.2)",
      value_37: "rgba(52, 186, 228, 0.1)",
      value_38: "#F4F5F8",
      value_39: "rgba(40, 57, 96, 0.5)",
    },
    boxShadows: {
      value_01: "0px 4px 30px rgba(40, 57, 96, 0.15)",
      value_02: "0px 15px 60px rgba(40, 57, 96, 0.15)",
      value_03: "0px 15px 20px rgba(0, 0, 0, 0.1)",
      value_04: "0px 15px 20px rgba(40, 57, 96, 0.1)",
      value_05: "0 4px 30px rgba(40, 57, 96, 0.15)",
      value_06: "0 -14px 14px rgba(40, 57, 96, 0.05)",
      value_07: "0px 10px 60px rgba(40, 57, 96, 0.1)",
      value_08: "0px 32px 32px rgba(0, 0, 0, 0.1)",
      value_09: "0px 15px 20px rgba(0, 0, 0, 0.1)",
      value_10: "0px 18px 32px rgba(40, 57, 96, 0.05)",
      value_11: "0px 10px 60px rgba(1, 19, 61, 0.18)",
    },
  },
  DARK: {
    colors: {
      value_01: "#f8fafc",
      value_02: "#000000",
      value_03: "#1976d2",
      value_04: "#3f51b5",
      value_05: "#79D3CD",
      value_06: "#4ec7bd",
      value_07: "#727272",
      value_08: "#EFEFEF",
      value_09: "#FCAE9D",
      value_10: "#767676",
      value_11: "#A7A4A4",
      value_12: "#B2B2B2",
      value_13: "#FF0000",
      value_14: "#F0FEFF",
      value_15: "#565656",
      value_16: "#334155",
      value_17: "#e2e8f0",
      value_18: "#334155",
      value_19: "#E5E5E5",
      value_20: "#60a5fa",
      value_21: "#0f172a",
      value_22: "#4FC8EE",
      value_23: "#606B84",
      value_24: "#F9F9FB",
      value_25: "#d3d3d3",
      value_26: "#B6BAC2",
      value_27: "#e2e8f0",
      value_29: "#94a3b8",
      value_30: "#352479",
      value_31: "#475569",
      value_32: "#64748b",
      value_33: "#1e293b",
      value_34: "#22c55e",
      value_35: "#f87171",
      value_36: "#DBCA30",
      value_37: "#CCD2E3",
      value_38: "#289d60",
      value_39: "#E43434",
      value_40: "#E45E34",
      value_41: "#B6E434",
      value_42: "#3446E4",
      value_43: "#34E446",
      value_44: "#EFA35D",
      value_45: "#0b1120",
      value_46: "#F0C350",
      value_47: "#0b1220",
      value_48: "#111827",
      value_51: "#4F4F4F",
      value_52: "#9DD1FF",
      value_53: "#BAD2FC",
      value_54: "#3347F2",
      value_55: "#3B2716",
      value_56: "#A9E44D",
      value_58: "#04091E",
      value_59: "#F0C350",
      value_60: "#FF8B92",
      value_61: "#FAEE86",
      value_62: "#A1EDA9",
      value_63: "#A0C0FF",
      value_64: "#4B5D7D",
      value_65: "#e2e8f0",
      value_66: "#e2e8f0",
      value_67: "#0f172a",
      value_68: "#111827",
    },
    rgb: {
      value_01: "#ffffff",
      value_02: "rgba(78, 92, 124, 0.25)",
      value_03: "rgba(2, 6, 23, 0.55)",
      value_04: "rgba(252, 210, 129, 0.45)",
      value_05: "rgba(255, 255, 255, 0.45)",
      value_06: "rgba(96, 165, 250, 0.12)",
      value_07: "rgba(255, 255, 255, 0.5)",
      value_08: "rgba(inherit, inherit, inherit, 0)",
      value_09: "rgba(40, 57, 96, 0.8)",
      value_10: "#cbd5e1",
      value_11: "#0f172a",
      value_12: "rgba(inherit, inherit, inherit, 0)",
      value_13: "rgba(148, 163, 184, 0.22)",
      value_14: "rgba(96, 165, 250, 0.16)",
      value_15: "rgba(15, 23, 42, 0.45)",
      value_16: "rgba(148, 163, 184, 0.12)",
      value_17: "rgba(96, 165, 250, 0.12)",
      value_18: "#e2e8f0",
      value_19: "rgba(96, 165, 250, 0.08)",
      value_20: "rgba(96, 165, 250, 0.14)",
      value_21: "rgba(15, 23, 42, 0.96)",
      value_22: "rgba(248, 113, 113, 0.14)",
      value_23: "rgba(34, 197, 94, 0.24)",
      value_24: "rgba(34, 197, 94, 0.14)",
      value_25: "rgba(96, 165, 250, 0.18)",
      value_26: "rgba(51, 65, 85, 0.55)",
      value_27: "rgba(226, 232, 240, 0.14)",
      value_28: "rgba(34, 197, 94, 0.18)",
      value_29: "rgba(15, 23, 42, 0.72)",
      value_30: "rgba(34, 197, 94, 0.12)",
      value_31: "#1e293b",
      value_32: "#0b1220",
      value_33: "rgba(15, 23, 42, 0.72)",
      value_34: "rgba(96, 165, 250, 0.16)",
      value_35: "rgba(248, 250, 252, 0.08)",
      value_36: "rgba(148, 163, 184, 0.14)",
      value_37: "rgba(96, 165, 250, 0.08)",
      value_38: "#111827",
      value_39: "rgba(15, 23, 42, 0.55)",
    },
    boxShadows: {
      value_01: "0px 4px 30px rgba(2, 6, 23, 0.35)",
      value_02: "0px 15px 60px rgba(2, 6, 23, 0.45)",
      value_03: "0px 15px 20px rgba(2, 6, 23, 0.35)",
      value_04: "0px 15px 20px rgba(15, 23, 42, 0.35)",
      value_05: "0 4px 30px rgba(2, 6, 23, 0.35)",
      value_06: "0 -14px 14px rgba(2, 6, 23, 0.18)",
      value_07: "0px 10px 60px rgba(2, 6, 23, 0.35)",
      value_08: "0px 32px 32px rgba(2, 6, 23, 0.4)",
      value_09: "0px 15px 20px rgba(2, 6, 23, 0.32)",
      value_10: "0px 18px 32px rgba(15, 23, 42, 0.28)",
      value_11: "0px 10px 60px rgba(2, 6, 23, 0.42)",
    },
  },
};
